<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>

        <b-modal ref="addItemModal" size="xl" hide-footer :title="titleModal">

            <b-row>
                <b-col col="12" md="3">
                    <b-form-group label="lager amount">
                        <b-input
                                v-model.number="amountItem.gram"
                                type="number"></b-input>
                    </b-form-group>
                </b-col>
                <b-col col="12" md="3">
                    <b-form-group label="title">
                        <b-input v-model="amountItem.title"></b-input>
                    </b-form-group>
                </b-col>
                <b-col col="12" md="3">
                    <b-form-group label="price">
                        <b-input
                                type="number"
                                v-model.number="amountItem.price"></b-input>
                    </b-form-group>
                </b-col>
                <b-col col="12" md="3">
                    <b-form-group label="action">

                        <template v-if="amountId > 0">
                            <b-button
                                    @click="updateAmountProduct"
                                    variant="success">save
                            </b-button>
                        </template>
                        <template v-else>
                            <b-button
                                    @click="storeAmountProduct"
                                    variant="success">save
                            </b-button>
                        </template>


                    </b-form-group>
                </b-col>
            </b-row>

            <br>
            <br>
            <h3>KASSA Items</h3>
            <template v-if="amounts.length > 0">
                <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>lager amount</th>
                            <th>title</th>
                            <th>price</th>
                            <th>action</th>
                        </tr>
                        </thead>


                        <tbody>
                        <tr v-for="(amount,index) in amounts" :key="index">
                            <td>{{ ++index }}</td>
                            <td>{{amount.gram}}</td>
                            <td>{{amount.title}}</td>
                            <td>{{amount.price | numFormat('0.00')}} €</td>
                            <td>
                                <a
                                        @click.prevent="selectProductSinglePriceFromKassaItems(amount)"
                                        href="#" class="btn btn-info mr-4">select</a>
                                <a
                                        @click.prevent="editAmount(amount)"
                                        href="#" class="text-primary mr-4">edit</a>

                                <a
                                        @click.prevent="deleteAmountPrice(amount.id)"
                                        href="#" class="text-danger">delete</a>

                            </td>
                        </tr>
                        </tbody>


                    </table>
                </div>
            </template>

            <template v-else>
                <b-alert show variant="info">
                    <p>no items found</p>
                </b-alert>
            </template>

        </b-modal>
        <!--modal add custom item-->


        <template v-if="isProcess">
            <ProcessNewOrder :productSelected="productSelected"></ProcessNewOrder>
        </template>

        <template v-else>
            <navbar>
                <template v-slot:navbarname>
                    <span>KASSA</span>
                </template>
            </navbar>


            <b-card style="z-index: 2" class="sticky-top" v-if="getCountProductsSelect.length > 0">
                <b-button @click="processNextStep" variant="success">Next Step</b-button>
                <span class="ml-4 font-weight-bold">{{getCountProductsSelect.length}} product selected</span>
            </b-card>

            <b-row>
                <b-col cols="12" md="3">

                    <b-input v-model="searchCategory" placeholder="search in categories ..."></b-input>

                    <b-card title="Categories" class="sticky-top" style="top: 85px">
                        <b-form-checkbox-group
                                v-model="filter.categories"
                                :options="getCategorySearch"
                                @change="onSelectFilter"
                                class="mb-3"
                                stacked
                                value-field="id"
                                text-field="title"
                        ></b-form-checkbox-group>
                    </b-card>
                </b-col>
                <b-col cols="12" md="9">
                    <b-input v-model="searchProduct" placeholder="search in products ..."></b-input>

                    <template v-if="products.length > 0">
                        <b-row>
                            <b-col v-for="(item,index) in products" :key="index" cols="12" md="4">
                                <b-card
                                        :class="{'border border-danger':item.is_unavailable}">

                                    <b-card-title>
                                        <h4 class="font-weight-bold" v-html="item.title"></h4>
                                    </b-card-title>

                                    <b-img class="w-100" height="85" style="object-fit: contain"
                                           :src="item.image"></b-img>
                                    <h3 class="text-center">
                                        <template v-if="item.is_offer">
                                            <p style="text-decoration: line-through" class="mb-0">{{item.price}}</p>
                                            <p class="mb-0 text-danger">{{item.price_sell}}</p>
                                        </template>
                                        <template v-else>
                                            <p class="mb-0">{{item.price}}</p>
                                        </template>
                                    </h3>

                                    <!--If Gram-->
                                    <template v-if="item.is_gram && item.amounts.length > 0">
                                        <b-form-select
                                                @input="prepareProduct">
                                            <template #first>
                                                <b-form-select-option disabled>select an option</b-form-select-option>
                                            </template>
                                            <b-form-select-option
                                                    v-for="(amount,index) in item.amounts"
                                                    :key="index"
                                                    :value="amount"
                                            >{{amount.title}}
                                            </b-form-select-option>

                                            <template v-if="item.amountsFactor.length > 0">
                                                <b-form-select-option
                                                        v-for="(amountFactor,indexFactor) in item.amountsFactor"
                                                        :key="indexFactor"
                                                        :value="amountFactor"
                                                >{{amountFactor.title}}
                                                </b-form-select-option>
                                            </template>

                                            <!--<b-form-select-option
                                                    value="addItem">custom item
                                            </b-form-select-option>-->
                                        </b-form-select>
                                    </template>

                                    <!--Else If Single Price-->
                                    <template
                                            v-else-if="item.amounts !== null && checkIfNotSelectAmountSinglePrice(item.id)">
                                        <b-button variant="info" @click="prepareProductSingle(item.amounts,item)">
                                            select
                                        </b-button>
                                    </template>

                                    <template v-if="checkIfNotSelectAmount(item.id)">
                                        <b-button variant="info" @click="selectAmount(item)">select</b-button>
                                    </template>
                                    <template v-else-if="checkIfSelectAmount(item.id)">
                                        <!--<b-button variant="danger" @click="deleteSelectedAmount(item.id)">delete
                                        </b-button>-->
                                        <b-form-spinbutton inline
                                                           min="1"
                                                           @input="updateCountAmount(item.id,$event)"></b-form-spinbutton>


                                        <!--show selected amounts-->
                                        <b-list-group v-if="getSelectAmounts(item.id).length > 0" class="mt-3">

                                            <b-list-group-item
                                                    v-for="(amountItem,amountIndex) in getSelectAmounts(item.id)"
                                                    :key="amountIndex"
                                                    class="d-flex justify-content-between align-items-center px-0">
                                                {{amountItem.amountTitle}}

                                                <template v-if="amountItem.amountPriceSell > 0">
                                                    <span style="text-decoration: line-through" class="mr-3">{{amountItem.amountPrice | numFormat('0.00')}} €</span>
                                                    <span class="text-danger">{{amountItem.amountPriceSell | numFormat('0.00')}} €</span>
                                                </template>
                                                <template v-else>
                                                    <span>{{amountItem.amountPrice | numFormat('0.00')}} €</span>
                                                </template>

                                            </b-list-group-item>


                                        </b-list-group>

                                    </template>


                                    <!--<template v-if="item.is_gram && item.amounts.length > 0">-->
                                        <div class="text-right mt-3">
                                            <b-button size="sm"
                                                      @click="getAmountsProduct(item)"
                                                      variant="primary">custom price
                                            </b-button>
                                        </div>
                                    <!--</template>-->

                                </b-card>
                            </b-col>

                            <infinite-loading :identifier="infiniteId" :distance="1"
                                              @infinite="getProducts"></infinite-loading>

                        </b-row>
                    </template>


                </b-col>
            </b-row>
        </template>


    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import {EventBus} from "../../Services/Eventbus/event-bus";
    import ProcessNewOrder from "./ProcessNewOrder";

    export default {
        name: "NewOrder",
        components: {ProcessNewOrder, Navbar},
        data() {
            return {
                page: 1,
                infiniteId: +new Date(),
                randomId: 1,
                myTrue: true,
                myFalse: false,
                isProcess: false,
                isSubmit: false,
                categories: [],
                products: [],
                amounts: [],
                filter: {
                    categories: []
                },
                productSelected: [],
                amountId: 0,
                amountItem: {
                    title: null,
                    price: 0,
                    gram: 1,
                },
                productId: 0,
                searchProduct: null,
                searchCategory: null,
                titleModal: null
            }
        },
        methods: {
            resetValuesAmount() {
                this.amountId = 0;
                this.amountItem.title = null;
                this.amountItem.price = 0;
                this.amountItem.gram = 1;
            },
            editAmount(myItem) {
                this.amountId = myItem.id;
                this.amountItem.title = myItem.title;
                this.amountItem.price = myItem.price;
                this.amountItem.gram = myItem.gram;
            },
            deleteAmountPrice(id) {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'product/price/delete/' + id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                Notification.success(response.data.message);
                                this.getAmountsProduct(this.productId, 'yes');
                                this.getProducts();

                            } else {
                                Notification.success(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }
            },
            storeAmountProduct() {

                if (this.amountItem.title === null) {
                    Notification.error("please enter title!");
                    return;
                }
                if (this.amountItem.price <= 0) {
                    Notification.error("please enter price!");
                    return;
                }

                this.$Progress.start();
                this.isSubmit = true;
                Http.post(Http.apiurlV2() + 'order/factor/store/product/amount/' + this.productId, this.amountItem)
                    .then(response => {
                        this.$Progress.finish();
                        this.isSubmit = false;
                        if (response.data.status_code === Http.ok()) {
                            let productId = response.data.data.productId;
                            Notification.success(response.data.message);
                            this.getAmountsProduct(productId, 'yes');
                            this.resetValuesAmount();
                            this.getProducts();
                        }
                    })
                    .catch(error => {
                        this.isSubmit = false;
                        this.$Progress.finish();
                    })
            },
            updateAmountProduct() {

                if (this.amountItem.title === null) {
                    Notification.error("please enter title!");
                    return;
                }
                if (this.amountItem.price <= 0) {
                    Notification.error("please enter price!");
                    return;
                }

                this.$Progress.start();
                this.isSubmit = true;
                Http.post(Http.apiurlV2() + 'order/factor/update/product/amount/' + this.amountId, this.amountItem)
                    .then(response => {
                        this.$Progress.finish();
                        this.isSubmit = false;
                        if (response.data.status_code === Http.ok()) {
                            let productId = response.data.data.productId;
                            Notification.success(response.data.message);
                            this.getAmountsProduct(productId, 'yes');
                            this.resetValuesAmount();
                            this.getProducts();
                        }
                    })
                    .catch(error => {
                        this.isSubmit = false;
                        this.$Progress.finish();
                    })
            },
            getAmountsProduct(myItem, isServer = 'no') {
                this.showModal();
                this.$Progress.start();
                this.isSubmit = true;
                this.titleModal = myItem.title;
                let myId = 0;

                if (isServer === 'yes') {
                    this.productId = myItem;
                    myId = myItem;
                } else {
                    this.productId = myItem.id;
                    myId = myItem.id;
                }


                Http.get(Http.apiurlV2() + 'order/factor/get/product/amount/' + myId)
                    .then(response => {
                        this.$Progress.finish();
                        this.isSubmit = false;
                        if (response.data.status_code === Http.ok()) {
                            this.amounts = [];
                            this.amounts = response.data.data.prices;
                        }
                    })
                    .catch(error => {
                        this.isSubmit = false;
                        this.$Progress.finish();
                    })
            },
            showModal() {
                this.$refs['addItemModal'].show()
            },
            hideModal() {
                this.$refs['addItemModal'].hide()
            },
            updateCountAmount(id, event) {
                let findItem = this.productSelected.find(item => item.product_id === id);
                if (findItem && findItem.selected) {
                    findItem.count = event;
                }
            },
            checkIfNotSelectAmountSinglePrice(id) {
                let findItem = this.productSelected.find(item => item.product_id === id);
                return !findItem;
            },
            checkIfNotSelectAmount(id) {
                let findItem = this.productSelected.find(item => item.product_id === id);
                if (findItem && !findItem.selected) {
                    return true;
                } else {
                    return false;
                }
            },
            checkIfSelectAmount(id) {
                let findItem = this.productSelected.find(item => item.product_id === id);
                if (findItem && findItem.selected) {
                    return true;
                } else {
                    return false;
                }
            },
            getSelectAmounts(id) {
                let findItem = this.productSelected.filter(item => item.product_id === id);
                if (findItem.length > 0) {
                    return findItem;
                }
                return [];
            },
            deleteSelectedAmount(id) {
                let findItem = this.productSelected.find(item => item.product_id === id);
                if (findItem && findItem.selected) {
                    this.productSelected.splice(this.productSelected.indexOf(findItem), 1);
                }
            },
            selectAmount(product) {
                let findItem = this.productSelected.find(item => item.product_id === product.id);
                if (findItem) {
                    if (product.is_package) {
                        findItem.packageItems = product.packageItems;
                    }
                    findItem.selected = true;
                }
            },
            prepareProduct(amount, isSingle = false) {
                if (amount === 'addItem') {
                    this.showModal();
                } else {
                    /*let findItem = this.productSelected.find(item => item.product_id === amount.product_id);
                    if (findItem) {
                        findItem.amount_id = amount.id
                    } else {
                        this.productSelected.push({
                            product_id: amount.product_id,
                            amount_id: amount.id,
                            count: 1,
                            selected: isSingle,
                            packageItems: [],
                        });
                    }*/

                    this.productSelected.push({
                        product_id: amount.product_id,
                        amount_id: amount.id,
                        count: 1,
                        selected: isSingle,
                        amountTitle: amount.title,
                        amountPrice: amount.price,
                        amountPriceSell: amount.price_sell,
                        packageItems: [],
                    });
                }

            },
            prepareProductSingle(amount, product) {
                let findItem = this.productSelected.find(item => item.product_id === amount.product_id);
                if (findItem) {
                    findItem.amount_id = amount.id
                } else {
                    this.productSelected.push({
                        product_id: amount.product_id,
                        amount_id: amount.id,
                        count: 1,
                        selected: true,
                        amountTitle: amount.title,
                        amountPrice: amount.price,
                        amountPriceSell: amount.price_sell,
                        packageItems: (product.is_package ? product.packageItems : []),
                    });
                }
            },
            selectProductSinglePriceFromKassaItems(amount) {
                let findItem = this.productSelected.find(item => item.product_id === amount.product_id);
                if (findItem) {
                    findItem.amount_id = amount.id
                } else {
                    this.productSelected.push({
                        product_id: amount.product_id,
                        amount_id: amount.id,
                        count: 1,
                        selected: true,
                        amountTitle: amount.title,
                        amountPrice: amount.price,
                        amountPriceSell: amount.priceSell,
                        packageItems: [],
                    });
                }

                this.hideModal();
            },
            getProducts($state) {
                this.$Progress.start();
                this.isSubmit = true;
                Http.post(Http.apiurlV2() + 'order/factor/index?page=' + this.page, {
                    categories: this.filter.categories,
                    search: this.searchProduct
                })
                    .then(response => {
                        this.$Progress.finish();
                        this.isSubmit = false;
                        if (response.data.status_code === Http.ok()) {
                            this.categories = response.data.data.categories;

                            // check if search product is empty
                            if (this.checkSearchProductIsNull) {
                                if (response.data.data.products.length > 0) {
                                    this.page += 1;
                                    this.products.push(...response.data.data.products);
                                    $state.loaded();
                                } else {
                                    $state.complete();
                                }
                            } else {
                                this.products = response.data.data.products;
                            }


                        }
                    })
                    .catch(error => {
                        this.isSubmit = false;
                        this.$Progress.finish();
                    })
            },
            processNextStep() {
                EventBus.$emit('newOrderProductSelected', this.productSelected);
                this.isProcess = true;
            },
            onSelectFilter() {
                this.page = 1;
                this.infiniteId += 1;
                this.products = [];
                this.getProducts();
            },
        },
        watch: {
            searchProduct(after, before) {
                this.onSelectFilter();
            }
        },
        computed: {
            checkSearchProductIsNull() {
                return this.searchProduct === null || this.searchProduct === "";
            },
            getCountProductsSelect() {
                if (this.productSelected.length === 0) {
                    return 0;
                }

                return this.productSelected.filter(item => {
                    return item.selected === true;
                })
            },
            getCategorySearch() {
                if (this.searchCategory === null) {
                    return this.categories;
                }

                return this.categories.filter(item => {
                    return item.title.toLowerCase().match(this.searchCategory.toLowerCase())
                })
            },
        },
        created() {
            this.getProducts();
        },
        mounted() {
            let myThis = this;
            EventBus.$on('cancelOrder', function (payload) {
                if (payload === 'yes') {
                    myThis.isProcess = false;
                }
            });
            EventBus.$on('updateCart', function (payload) {
                if (payload !== null) {
                    myThis.productSelected = [];

                    payload.filter(item => {
                        myThis.productSelected.push({
                            product_id: item.id,
                            amount_id: item.amount_id,
                            count: 1,
                            selected: true,
                            amountTitle: item.amount_title,
                            amountPrice: item.price,
                            amountPriceSell: item.price_sell,
                            packageItems: [],
                        });
                    });
                }
            });
            EventBus.$on('deleteAllCart', function (payload) {
                if (payload === 'yes') {
                    myThis.isProcess = false;
                    myThis.productSelected = [];
                }
            });
        }
    }
</script>

<style scoped>

</style>